import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import { createStyles, Theme } from '@material-ui/core';

const styles = (theme: Theme) => createStyles({
    textField: {
        width: 'auto'
    }
});

interface TextFieldErrorAttributes {
    classes: any;
    name: string;
    label: string;
    value: any;
    errorText?: string;
    handleChange: (event: object) => void;
    onKeyPress?: (event: React.KeyboardEvent) => any;
    type?: string;
    disabled: boolean;
}

const TextFieldWithError = (props: TextFieldErrorAttributes) => {

    const { classes, label, name, value, handleChange, type, disabled } = props;
    const errorText = props.errorText != null ? props.errorText : "";

    let actualType = type || "text";

	return (
		<FormControl className={classes.textField} aria-describedby={name}>
			<InputLabel htmlFor={name}>{label}</InputLabel>
            <Input id={name} name={name} type={actualType} value={value} onChange={handleChange} onKeyPress={props.onKeyPress ? props.onKeyPress : undefined} disabled={disabled} />
			<FormHelperText id={`${name}-error`} error>{errorText}</FormHelperText>
		</FormControl>
	);
}
TextFieldWithError.muiName = "TextFieldWithError";

export default withStyles(styles)(TextFieldWithError);
